import { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import GenericTable from "../../DynamicComp/Table";
import Button from "../../DynamicComp/Button";
import Input from "../../DynamicComp/Input";
import Selector from "../../DynamicComp/Selector";
import { deleteData, getData, postData, putData } from "../../../global/Globalapi";

export default function Welcome() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    username: "",
    userpassword: "",
    user_type: '',
    userstatus: '',
  });

  const [data, setData] = useState([]);
  const [userTypes, setUserTypes] = useState([]);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchData = async () => {
    try {
      const response = await getData("/user_data");
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchUserTypes = async () => {
    try {
      const response = await getData("/usertypes");
      setUserTypes(response.data);
    } catch (error) {
      console.error("Error fetching user types:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchUserTypes();
  }, []);

  const handleChange = (eventOrValue, name) => {
    if (typeof eventOrValue === "object" && eventOrValue.target) {
      const { name, value } = eventOrValue.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: eventOrValue }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      if (editId) {
        // Update existing user
        const response = await putData(
          `/userupdate/${editId}`,
          formData
        );
        alert(response.data.message);
      } else {
        // Create new user
        const response = await postData(
          "/userregister",
          formData
        );
        alert(response.data.message);
      }

      // Refresh data and reset form
      fetchData();
      handleCancel();
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.message || 
                          "Operation failed!";
      alert(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEdit = (user) => {
  console.log("Editing user:", user);

  setFormData({
    first_name: user.first_name,
    email: user.email,
    phone: user.phone,
    username: user.username,
    password: user.password,
    usertype: user.user_type_name,
    userstatus: user.status,
  });

  setEditId(user.user_id);
  setShowForm(true);
};

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        console.log("Deleting user with ID:", id);
        const response = await deleteData(
          `/userdelete/${id}`
        );
        alert(response.data.message);
        fetchData(); // Refresh the user list
      } catch (error) {
        const errorMessage = error.response?.data?.message || 
                            error.message || 
                            "Failed to delete user";
        alert(errorMessage);
      }
    }
  };

  const handleCancel = () => {
    setFormData({ 
      name: "", 
      email: "", 
      phone: "", 
      username: "", 
      password: "", 
      user_type_name: "", 
      status: '' 
    });
    setEditId(null);
    setShowForm(false);
  };

  const columns = [
    { key: "first_name", label: "Name", sortable: false },
    { key: "email", label: "Email", sortable: false },
    { key: "phone", label: "Mobile", sortable: false },
    { key: "username", label: "Username", sortable: false },
    { key: "password", label: "Password", sortable: false },
    { key: "user_type_name", label: "User Type", sortable: false },
    { key: "status", label: "Status", sortable: false },
    { 
      key: "actions", 
      label: "Actions",
      align: "center",
      width: "120px"
    },
  ];

  const customRenderers = {
    actions: (row) => (
      <div className="flex gap-2 justify-center">
        <button
          className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600"
          onClick={() => handleEdit(row)}
        >
          <FaEdit />
        </button>
        <button
          className="bg-red-700 text-white px-2 py-1 rounded hover:bg-red-600"
          onClick={() => handleDelete(row.user_id)}
        >
          <FaTrashAlt />
        </button>
      </div>
    ),
    usertype: (row) => (
      <span className={`px-2 py-1 rounded-full text-xs ${
        row.usertype === 'Admin' ? 'bg-purple-100 text-purple-800' : 
        row.usertype === 'staff' ? 'bg-blue-100 text-blue-800' : 
        'bg-green-100 text-green-800'
      }`}>
        {row.user_type}
      </span>
    ),
    userstatus: (row) => (
      <span className={`px-2 py-1 rounded-full text-xs ${
        row.userstatus === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
      }`}>
        {row.userstatus}
      </span>
    )
  };

  const toTitleCase = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

  const userTypeOptions = [
    { value: "", label: "Select User Type" },
    ...userTypes.map(type => ({
      value: type.user_type_name,
      label: type.user_type_name
    }))
  ];

  const userStatus = [
    { value: "", label: "Select User Status" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" }
  ];

  return (
    <div className="flex flex-col items-center min-h-screen w-full p-8 bg-gray-50">
      <div className="bg-white p-6 rounded-xl shadow-lg w-full overflow-x-auto mb-8">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-black text-center flex-grow">User </h2>

          <Button
            onClick={() => {
              setShowForm(true);
              setEditId(null);
              setFormData({ 
                name: "", 
                email: "", 
                phone: "", 
                username: "", 
                password: "", 
                user_type_name: "", 
                status: '' 
              });
            }}
            variant="danger"
            className="p-2 rounded-lg flex items-center space-x-2"
          >
            <FaPlus />
            <span>Add User</span>
          </Button>
        </div>

        <div className="w-full border-collapse">
          <GenericTable
            columns={columns}
            data={data}
            customRenderers={customRenderers}
            headerClassName="bg-red-700 text-white"
            rowKey="id"
            stripedRows={true}
            hoverEffect={true}
            rowsPerPageOptions={[5, 10, 20]}
          />
        </div>
      </div>

      {showForm && (
        <div className="bg-white p-6 rounded-xl shadow-lg w-full">
          <h2 className="text-2xl font-bold text-left mb-4 text-black">
            {editId ? "Edit User" : "Create User"}
          </h2>
          <form onSubmit={handleSubmit} className="grid grid-cols-5 gap-4">
            {["first_name", "email", "phone", "username", "password"].map((field) => (
              <div key={field} className="col-span-1">
                <Input
                  type={field === 'email' ? 'email' : field === 'userpassword' ? 'password' : 'text'}
                  label={toTitleCase(field)}
                  name={field}
                  value={formData[field] || ""}
                  onChange={handleChange}
                  placeholder={`Your ${field}`}
                  required={true}
                  labelColor="text-gray-700 font-semibold"
                  inputClassName="placeholder-gray-700"
                />
              </div>
            ))}

            <div className="col-span-1">
              <label className="text-gray-700 font-semibold">User Type*</label>
              <Selector
                options={userTypeOptions}
                name="usertype"
                value={formData.usertype}
                onChange={handleChange}
                required={true}
              />
            </div>

            <div className="col-span-1">
              <label className="text-gray-700 font-semibold">User Status*</label>
              <Selector
                options={userStatus}
                name="userstatus"
                value={formData.userstatus}
                onChange={handleChange}
                required={true}
              />
            </div>

            <div className="col-span-5 flex justify-end space-x-4">
              <Button 
                type="submit" 
                variant="danger" 
                className="px-6 py-2 rounded-lg"
                disabled={isSubmitting}
              >
                {editId ? "Update" : "Submit"}
              </Button>
              <Button
                onClick={handleCancel}
                type="button"
                variant="danger"
                className="px-6 py-2 rounded-lg"
              >
                Cancel
              </Button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}